import axios from 'axios';
import config from 'config';
import { finalize } from "actions/URLfinalizer";

import toastr from 'toastr';

import * as overviewAction from "./overview"
import * as nodeAction from "./node"
import store from '../store';
/**
 * Floorplan image related
 */
export const FETCH_IMAGE = 'FETCH_IMAGE';
export const RECEIVE_IMAGE = 'RECEIVE_IMAGE';

export function fetchImage(id) {
	return {
		type: FETCH_IMAGE,
		id: id
	}
}

export function receiveImage(result) {
	return {
		type: RECEIVE_IMAGE,
		data: result.data
	}
}

/**
 * Floorplan sensor related
//  */
export const SAVE_SENSOR = 'SAVE_SENSOR';
export const SAVE_SENSOR_COMPLETED = 'SAVE_SENSOR_COMPLETED';
export const SAVE_SENSOR_FAILED = 'SAVE_SENSOR_FAILED';
export const UPDATE_SENSOR = 'UPDATE_SENSOR';
export const UPDATE_SENSOR_COMPLETED = 'UPDATE_SENSOR_COMPLETED';
export const UPDATE_SENSOR_FAILED = 'UPDATE_SENSOR_FAILED';

export function updateSensor(sensor) {
	return dispatch => {
		dispatch(updateSensorInProgress(sensor));
		return axios.put(finalize(config.api.root + `/sensor/update/${sensor.id}`), sensor)
			.then((response) => {
				// Dirty hack !
				var ss = Object.assign({}, store.getState().nodeReducer.map.get(sensor.id), sensor);
				store.getState().nodeReducer.map.set(sensor.id, ss);

				dispatch(nodeAction.fetchLiveData());
				dispatch(overviewAction.fetchCustomerOverview());
				return response;
			})
			.catch(function (response) {
				toastr.error("Move sensor failed : ", response);
				dispatch(updateSensorFailed(response.data));
				return response;
			})
	}
}

export function updateSensorInProgress(sensor) {
	return {
		type: UPDATE_SENSOR,
		sensor
	}
}

export function updateSensorFailed(data) {
	return {
		type: UPDATE_SENSOR_FAILED,
		data
	}
}

export function updateSensorCompleted() {
	return {
		type: UPDATE_SENSOR_COMPLETED
	}
}

export function saveSensor(sensor) {
  return {
    type: SAVE_SENSOR,
    sensor
  }
}

export function saveSensorCompleted(sensor) {
  return {
    type: SAVE_SENSOR_COMPLETED,
    sensor
  }
}

export function saveSensorFailed() {
  return {
    type: SAVE_SENSOR_FAILED
  }
}

export function createSensor(id, sensor) {
  return dispatch => {
    dispatch(saveSensor(sensor));
    return axios.post(finalize(config.api.root + `/sensor/create/0/${id}`), sensor)
      .then((response) => {
        dispatch(saveSensorCompleted(response.data));
        return response;
      })
      .catch(function (response) {
        dispatch(saveSensorFailed());
        return response;
      })
  }
}




// WEBPACK FOOTER //
// ./src/actions/floorplan.js